export enum StorageServiceProvider {
  FIREBASE = "firebase",
}
